import React from 'react'
import icon_alert from './images/alert.svg'

export const ModalVouchersInactivation = ({ title, message, closeModal, ...rest }) => {
  return (
    <div className="vouchers_inactivation_modal">
      <div className="vouchers_inactivation_modal_content">
        <div className="vouchers_inactivation_modal_header">
          <img className="vouchers_inactivation_modal_icone" src={icon_alert} alt="Ícone de alerta" />
          <h3 className="vouchers_inactivation_modal_title">{title}</h3>
        </div>
        <div className="vouchers_inactivation_modal_main">{message()}</div>
        <div className="vouchers_inactivation_modal_footer">
          <button
            className="vouchers_inactivation_modal_close"
            onClick={() => {
              closeModal()
            }}
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  )
}
